import { isDesktopRuntime } from './desktopDetection';

/**
 * T-0894 (`docs/concept-mobile-app.md`, LC-6g): where a passkey ceremony runs, without the sheet
 * itself. The launch entry reaches a ceremony through the sign-in (`AuthStore`) and an answer's
 * presence confirmation (`passkeyAssertion.ts`), and a browser tab never runs one in the desktop's
 * sheet, so the entry asks only this: the sheet (`passkeySheet.ts`, its callback scheme and its
 * sentences) is loaded when a ceremony is handed to it.
 */

/**
 * Whether this page has to hand its ceremonies to the sheet. Only the desktop shell does: a browser
 * tab and the phone app's webview run their own.
 */
export function ceremoniesRunInTheSheet(): boolean {
  return isDesktopRuntime();
}

/** The desktop's passkey sheet, loaded on the first ceremony handed to it. */
export function loadPasskeySheet(): Promise<typeof import('./passkeySheet')> {
  return import('./passkeySheet');
}
